<template>
 <div class="top_tastes_container">
    <p class="top_tastes_text color_grey-black">топ вкусы</p>
    <div class="top_tastes_block_all">
      <div class="mixed_berry">
        <p class="mixed_berry_name color_white">mixed<br />berry</p>
        <p class="mixed_berry_20k color_white">20k</p>
        <p class="mixed_berry_mg color_white">20mg</p>
      </div>
      <div class="lush_ice">
        <p class="mixed_berry_name color_red">lush ice</p>
        <p class="mixed_berry_20k color_red">20k</p>
        <p class="mixed_berry_mg color_red">20mg</p>
      </div>
      <div class="raspberry_root_soda">
        <p class="mixed_berry_name color_grey-black">
          raspberry <br />root <br />soda
        </p>
        <p class="mixed_berry_20k color_grey-black">20k</p>
        <p class="mixed_berry_mg color_grey-black">20mg</p>
      </div>
      <div class="grape_ice_soda">
        <p class="mixed_berry_name color_red">grape ice</p>
        <p class="mixed_berry_20k color_red">20k</p>
        <p class="mixed_berry_mg color_red">20mg</p>
      </div>
    </div>
  </div>
</template>